<template>
  <v-dialog v-model="show" persistent max-width="480px">
    <v-card>
      <v-card-title class="pt-0 px-0">
        <v-toolbar color="primaryLight" dark dense>
          <v-toolbar-title>Editar estados</v-toolbar-title>
        </v-toolbar>
      </v-card-title>

      <v-card-text id="estadosData" class="my-5">
        <v-row v-for="(estado, i) in estadosEmergencia" :key="i" style="height: 60px;" class="mb-2 align-center justify-center">
          <v-col cols="auto" style="width: 140px;">
            <v-chip class="d-flex justify-center align-center" :color="estado.COLOR">
              {{ estado.EMERGENCIA_ESTADO }}
            </v-chip>
          </v-col>
          <v-col v-if="i === 4 && disableFinalizar">
            <p>
              Es necesario finalizar las actuaciones de los medios y finalizar el ultimo nivel del incendio
            </p>
          </v-col>
          <v-col cols="auto" v-else>
            <v-form>
              <vx-date-text-edit
                v-model="fechaEstados[i]"
                label="Fecha"
                v-facade="mask"
                icon="esri-icon-calendar"
                @focus="setCurrentDate(i)"
                :min="dateMin[i]"
                :max="dateMax[i]"
                :between="dateBetween[i]"
                :disabled="disabledStates[i]"
                ref="form"
              /> <!-- not future quitado -->
            </v-form>
          </v-col>

          <v-col cols="auto">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn icon color="red" v-bind="attrs" v-on="on" :disabled="disabledStates[i]" @click="removeFecha(i)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar fecha salida.</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-checkbox v-model="autoComplete" label="Autocompletar" />
        <v-spacer />
        <v-btn color="red" text @click="cerrar">Cerrar</v-btn>
        <v-btn color="green" text :disabled="!isValid" @click="isFalsaAlarma">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DateService, { FMT, DayjsUnit } from '@/helpers/DateService'
export default {
  props: {
    show: Boolean,
    emergencia: Object
  },

  data: () => ({
    mask: '##/##/#### ##:##',

    sortedEstados: [],
    disabledStates: [],
    textFocus: undefined,
    autoComplete: true,
    fechaEstados: [],
    dateMin: [],
    dateMax: [],
    dateBetween: []
  }),

  watch: {
    show () {
      if (this.show) {
        this.textFocus = undefined
        this.getFechaEstados()
      }
    },
    fechaEstados (newVal, oldVal) {
      this.fechaEstadosChange()
      if (this.textFocus || this.textFocus === 0) {
        if (this.textFocus === 5) {
          if (this.fechaEstados[this.textFocus]) {
            this.disableSubsequentDates(0)
          } else {
            this.enableSubsequentDates(0)
          }
        } else if (!this.fechaEstados[this.textFocus]) {
          this.disableSubsequentDates(this.textFocus)
        } else if (!this.fechaEstados[5]) {
          this.enableSubsequentDates(this.textFocus)
        }
      }
    }
  },

  computed: {
    ...mapGetters('emergencia', ['emergenciaEstadoTipo']),

    estadosEmergencia () {
      return this.emergenciaEstadoTipo
    },

    isValid () {
      if (!this.fechaEstados[0] || this.fechaEstados[0] === '') {
        return false
      }

      // Comprobamos que no haya huecos
      let a = this.fechaEstados.findIndex(x => x === '' || !x)
      let b = this.fechaEstados.findLastIndex(x => x && x !== '')

      if (b > a && b !== 5) {
        return false
      }

      for (let i = 0; i < this.fechaEstados.length; i++) {
        if (this.fechaEstados[i] && this.fechaEstados[i] !== '') {
          const fechaFueraLimites = this.$date.parseDate(this.dateMin[i]) > this.$date.parseDate(this.fechaEstados[i]).toDate() || this.$date.parseDate(this.dateMax[i]) < this.$date.parseDate(this.fechaEstados[i]).toDate()
          const fechaLongitud = this.fechaEstados[i].length !== this.mask.length
          if (fechaLongitud || fechaFueraLimites) {
            return false
          }
        }
      }

      return true
    },
    disableFinalizar () {
      if (this.emergencia && Object.keys(this.emergencia).length > 0) {
        return !this.actuacionesCerradas || this.showNivelesTable
      } else {
        return false
      }
    },
    showNivelesTable () {
      return this.emergencia.INCENDIO.NIVELES && this.emergencia.INCENDIO.NIVELES.length > 0
    },
    actuacionesCerradas () {
      for (let i = 0; i < this.emergencia.SECTORES.length; i++) {
        let sector = this.emergencia.SECTORES[i]

        for (let j = 0; j < sector.MEDIOS.length; j++) {
          let medio = sector.MEDIOS[j]

          if (!medio.FECHA_LLEGADA_BASE) {
            return false
          }
        }
      }
      return true
    }
  },

  methods: {
    disableSubsequentDates (pos) {
      for (let i = this.estadosEmergencia.length - 2; i > pos; i--) {
        this.disabledStates[i] = true
      }
    },
    enableSubsequentDates (pos) {
      for (let i = this.estadosEmergencia.length - 2; i > pos; i--) {
        if (this.fechaEstados[i] || (!this.fechaEstados[i] && this.fechaEstados[i - 1])) {
          this.disabledStates[i] = false
        }
      }
    },

    fechaEstadosChange () {
      for (let i = 0; i < this.estadosEmergencia.length; i++) {
        this.getMinDate(i)
        this.getMaxDate(i)
        this.getBetweenDate(i)
      }
    },

    removeFecha (pos) {
      this.textFocus = pos
      this.$set(this.fechaEstados, this.textFocus, null)
      this.getMinDate(this.textFocus)
      this.getMaxDate(this.textFocus)
      this.getBetweenDate(this.textFocus)
    },

    getFechaEstados () {
      if (this.emergencia) {
        this.fechaEstados = new Array(this.estadosEmergencia.length).fill(null)
        this.sortedEstados = [...this.emergencia.ESTADOS]
          .sort((estado1, estado2) => {
            return estado1.EMERGENCIA_ESTADO_TIPO.VALUE - estado2.EMERGENCIA_ESTADO_TIPO.VALUE
          })

        this.sortedEstados.forEach(estado => {
          this.fechaEstados[estado.EMERGENCIA_ESTADO_TIPO.VALUE] = this.$date
            .parseDate(estado.FECHA)
            .format(FMT.date)
        })
      }

      this.disabledStates = new Array(this.estadosEmergencia.length).fill(false)

      for (let i = 0; i < this.estadosEmergencia.length; i++) {
        if (i !== 0 && i !== 5 && !this.fechaEstados[i - 1]) {
          this.disabledStates[i] = true
        }
        if (this.fechaEstados[5] && i !== 0 && i !== 5) {
          this.disabledStates[i] = true
        }
      }
    },

    setCurrentDate (pos) {
      this.textFocus = pos
      if (pos === 5) {
        for (let i = 4; i > 0; i--) {
          if (this.fechaEstados[i]) {
            this.textFocus = i
            this.$set(this.fechaEstados, i, null)
            this.fechaEstadosChange()
          }
        }
        this.textFocus = 5
        this.dateBetween = []
      }

      this.getMinDate(pos)
      this.getMaxDate(pos)
      this.getBetweenDate(pos)
      if ((!this.fechaEstados[pos] || this.fechaEstados[pos] === '') && this.autoComplete) {
        const currentDate = this.$date.currentDate()
        this.$set(this.fechaEstados, pos, currentDate)
      }
    },

    getMinDate (pos) {
      if (pos === 5) {
        this.dateMin[pos] = this.fechaEstados[0]
          ? this.$date
            .parseDate(this.fechaEstados[0])
            .add(1, DayjsUnit.Minute)
            .format(FMT.date)
          : null
      } else {
        this.dateMin[pos] = this.fechaEstados[pos - 1]
          ? this.$date
            .parseDate(this.fechaEstados[pos - 1])
            .add(1, DayjsUnit.Minute)
            .format(FMT.date)
          : null
      }
    },

    getMaxDate (pos) {
      if (this.fechaEstados[5] && this.fechaEstados[5] !== '') {
        return
      }
      if (pos === 0 && !this.fechaEstados[pos + 1]) {
        this.dateMax[pos] = this.fechaEstados[5]
          ? this.$date
            .parseDate(this.fechaEstados[5])
            .add(-1, DayjsUnit.Minute)
            .format(FMT.date)
          : null
      } else {
        this.dateMax[pos] = this.fechaEstados[pos + 1]
          ? this.$date
            .parseDate(this.fechaEstados[pos + 1])
            .add(-1, DayjsUnit.Minute)
            .format(FMT.date)
          : null
      }
    },

    getBetweenDate (pos) {
      if (this.fechaEstados[5] && this.fechaEstados[5] !== '') {
        return
      }

      if (this.textFocus === 0 && !this.fechaEstados[pos + 1]) {
        this.dateBetween[pos] = this.fechaEstados[5]
          ? this.$date
            .parseDate(this.fechaEstados[5])
            .add(-1, DayjsUnit.Minute)
            .format(FMT.date)
          : null
      } else {
        this.dateBetween[pos] = this.fechaEstados[pos + 1]
          ? this.$date
            .parseDate(this.fechaEstados[pos + 1])
            .add(-1, DayjsUnit.Minute)
            .format(FMT.date)
          : null
      }
    },

    isFalsaAlarma () {
      // Si el nuevo estado es falsa alarma, pediremos confirmacion
      if (this.fechaEstados[5] && this.fechaEstados[5] !== '') {
        let msg = 'El estado pasará a falsa alarma, esto eliminará las actuaciones de los medios que no hayan llegado y dará salida a los que si.'
        this.$root.$confirmDialog.open('¿Está seguro?', msg, { html: true }).then(result => {
          if (result) {
            this.aceptar()
          }
        })
      } else {
        this.aceptar()
      }
    },

    aceptar () {
      if (!this.isValid) {
        return
      }

      if (this.emergencia) {
        let emergenciaEstadosAscendente = new Array(this.estadosEmergencia.length).fill(null)
        const sortedEstados = [...this.emergencia.ESTADOS].sort((estado1, estado2) => {
          return estado1.EMERGENCIA_ESTADO_TIPO.VALUE - estado2.EMERGENCIA_ESTADO_TIPO.VALUE
        })

        sortedEstados.forEach(estado => {
          emergenciaEstadosAscendente[estado.EMERGENCIA_ESTADO_TIPO.VALUE] = estado
        })

        // Si existe falsa alarma, la eliminamos la primera
        if (emergenciaEstadosAscendente[5] && (!this.fechaEstados[5] || this.fechaEstados[5] === '')) {
          let data = {
            ID_EMERGENCIA_ESTADO: emergenciaEstadosAscendente[5].ID_EMERGENCIA_ESTADO,
            ID_EMERGENCIA: emergenciaEstadosAscendente[5].ID_EMERGENCIA,
            NUEVO_ESTADO: emergenciaEstadosAscendente[0].EMERGENCIA_ESTADO_TIPO.EMERGENCIA_ESTADO
          }

          this.$store.dispatch('emergencia/deleteEstadoIncendio', data)
          setTimeout(() => {}, 1000)
        }
        for (let i = 0; i < this.estadosEmergencia.length; i++) {
          if (emergenciaEstadosAscendente[i] && this.fechaEstados[i] && this.$date.parseDate(emergenciaEstadosAscendente[i].FECHA).format(FMT.date) !== this.$date.parseDate(this.fechaEstados[i]).format(FMT.date)) {
            // console.log(emergenciaEstadosAscendente[i])

            let data = {
              ID_EMERGENCIA_ESTADO: emergenciaEstadosAscendente[i].ID_EMERGENCIA_ESTADO,
              ID_EMERGENCIA: emergenciaEstadosAscendente[i].ID_EMERGENCIA,
              ID_EMERGENCIA_ESTADO_TIPO: emergenciaEstadosAscendente[i].ID_EMERGENCIA_ESTADO_TIPO,
              CODIGO_TIPO_ESTADO: emergenciaEstadosAscendente[i].EMERGENCIA_ESTADO_TIPO.VALUE,
              FECHA: this.$date.parseDate(this.fechaEstados[i])
            }

            this.$store.dispatch('emergencia/editEstadoEmergencia', data)
            this.$emit('redrawEmergencia')
          }

          if (!emergenciaEstadosAscendente[i] && this.fechaEstados[i]) {
            let estadoEmergencia = {
              ID_EMERGENCIA_ESTADO: this.$uuid.createUUID(),
              ID_EMERGENCIA: this.emergencia.ID_EMERGENCIA,
              ID_EMERGENCIA_ESTADO_TIPO: this.estadosEmergencia[i].ID_EMERGENCIA_ESTADO_TIPO,
              FECHA: this.$date.parseDate(this.fechaEstados[i]),
              EMERGENCIA_ESTADO_TIPO: this.estadosEmergencia[i]
            }
            emergenciaEstadosAscendente[i] = estadoEmergencia
            this.$store.dispatch('emergencia/addEstadoEmergencia', estadoEmergencia).then(() => {
            }).catch((e) => {
              this.$notify({
                title: 'Cambio de estado',
                text: `Error al cambiar el estado del incendio a ${this.estadosEmergencia[i].EMERGENCIA_ESTADO}`,
                type: 'error'
              })
            })
          }
          // No se elimina 'Inicio' (no se puede) ni 'Falsa alarma' (se elimina antes del bucle)
          if (i !== 0 && i !== 5 && emergenciaEstadosAscendente[i] && (!this.fechaEstados[i] || this.fechaEstados[i] === '')) {
            let length = this.fechaEstados.filter(fecha => fecha !== '' && fecha !== null).length
            let newEstado = length - 1

            let data = {
              ID_EMERGENCIA_ESTADO: emergenciaEstadosAscendente[i].ID_EMERGENCIA_ESTADO,
              ID_EMERGENCIA: emergenciaEstadosAscendente[i].ID_EMERGENCIA,
              NUEVO_ESTADO: emergenciaEstadosAscendente[newEstado].EMERGENCIA_ESTADO_TIPO.EMERGENCIA_ESTADO
            }

            this.$store.dispatch('emergencia/deleteEstadoIncendio', data)
            setTimeout(() => {}, 1000)
          }

          // Si el estado es falsa alarma, eliminamos todos los medios que no han llegado y damos salida a los que si
          if (i === 5 && this.fechaEstados[i] && this.fechaEstados[i] !== '') {
            this.emergencia.SECTORES.forEach(sector => {
              sector.MEDIOS.forEach(medio => {
                if (!medio.FECHA_LLEGADA) {
                  medio.ID_EMERGENCIA = this.emergencia.ID_EMERGENCIA
                  this.$store.dispatch('emergencia/deleteMedioEmergencia', medio)
                } else if (!medio.FECHA_SALIDA) {
                  medio.ID_EMERGENCIA = this.emergencia.ID_EMERGENCIA
                  medio.FECHA_SALIDA = this.$date.parseDate(this.fechaEstados[i])
                  this.$store.dispatch('emergencia/editMedioEmergencia', medio)
                }
              })
            })
          }
        }
      }

      this.cerrar()
    },

    cerrar () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped></style>
